(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ac-styles"] && !Shopify.designMode) return;
  try {
    /* Art's Creams sections - shared script. Small, deferred, no libraries. */
(function () {
  if (window.AC) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(cents, fmt) {
    fmt = (fmt || '$' + '{' + '{amount}' + '}').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/, m = fmt.match(re);
    function d(n, dp, ts, ds) {
      var p = (n / 100).toFixed(dp).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p[1] ? p[0] + ds + p[1] : p[0];
    }
    if (!m) return d(cents, 2, ',', '.');
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = d(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = d(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = d(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = d(cents, 2, "'", '.'); break;
      default: v = d(cents, 2, ',', '.');
    }
    return fmt.replace(re, v);
  }

  function addToCart(items, btn, errEl) {
    var drawer = document.querySelector('cart-drawer');
    var body = { items: items };
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    if (useDrawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (errEl) errEl.textContent = '';
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) throw new Error(res.j.description || res.j.message || 'Sorry, something went wrong. Please try again.');
        if (useDrawer && res.j.sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res.j);
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ac', cartData: res.j }); } catch (e) {}
          giftSoon();
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (e) {
        if (errEl) errEl.textContent = e.message;
        else alert(e.message);
      })
      .then(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }

  // Cart drawer: swap a one-time neck cream for the routine. The routine goes
  // in first, so a failed add never loses her neck cream; then one neck cream
  // comes out. Anything unexpected falls back to opening the routine page.
  function swapToRoutine(a) {
    var drawer = document.querySelector('cart-drawer');
    var useDrawer = drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    var err = a.parentNode.querySelector('[data-ac-error]');
    var post = function (path, body) {
      return fetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || ''); return j; }); });
    };
    var item = { id: +a.getAttribute('data-ac-routine'), quantity: 1 };
    var bundle = a.getAttribute('data-ac-bundle');
    if (bundle) item.properties = { '_appstle-bb-id': bundle };
    a.setAttribute('aria-busy', 'true');
    post('cart/add.js', { items: [item] })
      .then(function () {
        var body = { id: a.getAttribute('data-ac-swap'), quantity: Math.max(0, (+a.getAttribute('data-ac-qty') || 1) - 1) };
        if (useDrawer) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }
        return post('cart/change.js', body);
      })
      .then(function (j) {
        if (useDrawer && j.sections) {
          drawer.renderContents(j);
          try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ac', cartData: j }); } catch (e) {}
          giftSoon();
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (e) {
        if (err && e.message) err.textContent = e.message;
        else window.location.href = a.href;
      })
      .then(function () { a.removeAttribute('aria-busy'); });
  }

  function BuyBox(el) {
    var data;
    try { data = JSON.parse(el.querySelector('[data-ac-json]').textContent); } catch (e) { return; }
    var fmt = el.getAttribute('data-money');
    var form = el.querySelector('form');
    var idInput = form.querySelector('[name=id]');
    var atc = el.querySelector('[data-ac-atc]');
    var atcLabel = atc ? atc.getAttribute('data-label') : '';
    var err = el.querySelector('[data-ac-error]');
    var subWrap = el.querySelector('[data-ac-opt=sub]');
    var state = { variant: +idInput.value, mode: 'onetime', plan: null, qty: 1 };
    // The pack may be picked when the page opens; ?pack=1 or ?pack=2 in the link picks one.
    var qtyPick = el.querySelector('[data-ac-qty]:checked');
    if (qtyPick) state.qty = +qtyPick.value || 1;
    try {
      var want = new URLSearchParams(location.search).get('pack');
      el.querySelectorAll('[data-ac-qty]').forEach(function (r) {
        if (want && r.value === want) { r.checked = true; state.qty = +want; }
      });
      var tag = new URLSearchParams(location.search).get('utm_content');
      el.querySelectorAll('[data-ac-utm]').forEach(function (n) {
        if (tag && tag.toLowerCase() === n.getAttribute('data-ac-utm').toLowerCase()) n.textContent = n.getAttribute('data-ac-utm-text');
      });
    } catch (e) {}
    // A product like the Even-Tone Set starts with no shade picked.
    var needMsg = el.getAttribute('data-ac-need');
    var picked = !needMsg;
    var pickName = el.querySelector('[data-ac-variant-name]');
    var pickPrompt = pickName ? pickName.textContent : '';
    var checkedMode = el.querySelector('[data-ac-mode]:checked');
    if (checkedMode) state.mode = checkedMode.value;
    var checkedPlan = el.querySelector('[data-ac-plan]:checked');
    if (checkedPlan) state.plan = +checkedPlan.value;
    // Each tube count can start on its own plan (1 tube: 2 months, 2 tubes: 3 months),
    // until she picks a plan herself.
    var planOne = +el.getAttribute('data-plan-one') || 0, planPack = +el.getAttribute('data-plan-pack') || 0;
    var planTouched = false;
    function planForQty() {
      if (planTouched) return;
      var p = state.qty > 1 ? (planPack || planOne) : (planOne || planPack);
      if (p) state.plan = p;
    }
    planForQty();

    function variant() {
      for (var i = 0; i < data.variants.length; i++) if (data.variants[i].id === state.variant) return data.variants[i];
      return data.variants[0];
    }
    // Money without ".00", e.g. "$13" or "$12.50".
    function whole(cents) { return money(cents, fmt).replace(/[.,]00(?=\D*$)/, ''); }
    function set(sel, txt) { el.querySelectorAll(sel).forEach(function (n) { n.textContent = txt; }); }

    function update() {
      var v = variant();
      var planIds = Object.keys(v.plans || {});
      var hasSub = planIds.length > 0;
      if (subWrap) subWrap.hidden = !hasSub;
      if (!hasSub) state.mode = 'onetime';
      if (hasSub && (!state.plan || !v.plans[state.plan])) state.plan = +planIds[0];
      el.querySelectorAll('[data-ac-plan]').forEach(function (p) {
        var ok = !!(v.plans && v.plans[p.value]);
        p.disabled = !ok;
        p.checked = +p.value === state.plan;
      });
      el.querySelectorAll('[data-ac-mode]').forEach(function (m) {
        m.checked = m.value === state.mode;
        var opt = m.closest('.ac-opt');
        if (opt) opt.classList.toggle('is-on', m.checked);
      });
      // A multi-pack (2 tubes) costs the pack price on a one-time order, and its
      // subscribed price (if set) on a subscription; automatic discounts in
      // Shopify make the cart match. Otherwise each tube gets the plan price.
      var q = state.qty, full = v.price * q;
      var once = data.pack && q === data.pack.qty ? data.pack.price : full;
      set('[data-ac-onetime-price]', money(once, fmt));
      // Each price box says how many tubes its price buys (Diane 10-30: with
      // only "One-time $35.99" under the 2-tube gift box, she couldn't tell).
      el.querySelectorAll('[data-ac-qty-tag]').forEach(function (n) { n.textContent = n.getAttribute(q === 1 ? 'data-one' : 'data-pack'); });
      if (v.sep > v.price) set('[data-ac-sep-save]', whole(v.sep - v.price));
      var price = once, planLabel = '';
      if (hasSub) {
        var sp = v.plans[state.plan] * q;
        if (data.pack && q === data.pack.qty && data.pack.sub) sp = data.pack.sub;
        set('[data-ac-sub-price]', money(sp, fmt));
        // Compare with the one-time price for the same number of tubes ($59.99 for 2),
        // so the % and strikethrough match what she sees in the box above.
        var base = once;
        var save = Math.max(base - sp, 0), perYear = 0;
        for (var i = 0; i < data.plans.length; i++) if (data.plans[i].id === state.plan) { planLabel = data.plans[i].label; perYear = data.plans[i].per_year || 0; }
        set('[data-ac-sub-save]', money(save, fmt));
        set('[data-ac-sub-pct]', base ? Math.round(save * 100 / base) : 0);
        set('[data-ac-sub-was]', money(base, fmt));
        // Whole dollars saved a year, e.g. "$347".
        set('[data-ac-sub-year]', whole(Math.floor(save * perYear / 100) * 100));
        el.querySelectorAll('[data-ac-sub-saveline],[data-ac-sub-was]').forEach(function (n) { n.hidden = !(save > 0); });
        el.querySelectorAll('[data-ac-sub-yearline]').forEach(function (n) { n.hidden = !(save > 0 && perYear > 0); });
        el.querySelectorAll('[data-ac-disclose]').forEach(function (n) {
          n.textContent = (n.getAttribute('data-template') || '')
            .replace(/\[price\]/g, money(sp, fmt))
            .replace(/\[plan\]/g, planLabel.toLowerCase());
        });
        if (state.mode === 'sub') price = sp;
      }
      payTerms(v, paySlot ? once : (state.mode === 'sub' && hasSub ? 0 : once));
      idInput.value = v.id;
      var qtyInput = form.querySelector('[name=quantity]');
      if (qtyInput) qtyInput.value = state.qty;
      var planInput = form.querySelector('[name=selling_plan]');
      if (planInput) {
        planInput.value = state.mode === 'sub' && hasSub ? state.plan : '';
        planInput.disabled = !(state.mode === 'sub' && hasSub);
      }
      if (atc) {
        atc.disabled = !v.available;
        atc.firstChild.textContent = v.available ? atcLabel : (atc.getAttribute('data-soldout') || 'Sold out');
      }
      el.querySelectorAll('[data-ac-variant]').forEach(function (r) { r.checked = picked && +r.value === v.id; });
      set('[data-ac-variant-name]', picked ? v.title : pickPrompt);
      document.dispatchEvent(new CustomEvent('ac:change', {
        detail: { price: money(price, fmt), sub: state.mode === 'sub', plan: planLabel, available: v.available,
          pick: data.pack ? (el.querySelector('.ac-opt.is-on [data-ac-qty-tag]') || {}).textContent : '' }
      }));
    }

    // Shop Pay Installments line. Shopify renders it for one tube's price, so
    // we swap in a fresh copy with the picked price (2 tubes) and only the
    // interest-free option. Subscriptions can't be paid in installments, so the
    // line lives in the one-time box, under its price (Arthur 10-30); without
    // that box it sits under the button and hides when Subscribe is picked.
    // The line loads Shop Pay's script (about half a second of phone CPU), so
    // it waits in a <template> until the page has loaded and gone quiet.
    var payBox = el.querySelector('[data-ac-payterms]'), payKey = '';
    var paySlot = el.querySelector('[data-ac-payslot]');
    var payMeta = null, payHost = null, payWait = null, payReady = false;
    function payInit() {
      if (!payBox || payReady) return;
      var tpl = payBox.querySelector('template');
      if (tpl) { payBox.appendChild(document.importNode(tpl.content, true)); tpl.parentNode.removeChild(tpl); }
      if (paySlot) paySlot.removeAttribute('data-wait');
      try { payMeta = JSON.parse(payBox.querySelector('shopify-payment-terms').getAttribute('shopify-meta')); } catch (e) { payBox = null; return; }
      if (paySlot) { paySlot.appendChild(payBox.querySelector('shopify-payment-terms')); payBox.hidden = true; }
      payHost = paySlot || payBox;
      payReady = true;
      if (payWait) payTerms(payWait[0], payWait[1]);
    }
    // It also waits until she scrolls near the price boxes, so a quick bounce
    // never downloads it (about 300 KB, Arthur 11-02).
    function payLater() { (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(payInit, { timeout: 2500 }); }
    function payWhenNear() {
      var spot = paySlot || payBox;
      if (!('IntersectionObserver' in window)) return payLater();
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); payLater(); }
      }, { rootMargin: '150px 0px' });
      io.observe(spot);
    }
    if (payBox) { if (document.readyState === 'complete') payWhenNear(); else window.addEventListener('load', payWhenNear); }
    function payTerms(v, cents) {
      if (!payBox) return;
      if (!paySlot) payBox.hidden = !cents;
      if (!payReady) { payWait = [v, cents]; return; }
      var key = v.id + ':' + cents;
      if (!cents || key === payKey) return;
      payKey = key;
      var amt = cents / 100, n = 0;
      (payMeta.financing_plans || []).forEach(function (fp) {
        if (amt < fp.min_price_amount || amt > fp.max_price_amount) return;
        fp.terms.forEach(function (t) { if (t.loan_type === 'split_pay' && t.installments_count > n) n = t.installments_count; });
      });
      var per = n ? Math.ceil(cents / n) : cents;
      var meta = JSON.parse(JSON.stringify(payMeta));
      // Only the interest-free split; the monthly plans with interest muddy the line.
      meta.financing_plans = (meta.financing_plans || []).map(function (fp) {
        fp.terms = fp.terms.filter(function (t) { return t.loan_type === 'split_pay'; });
        return fp;
      }).filter(function (fp) { return fp.terms.length; });
      meta.variants = [{ id: v.id, price_per_term: money(per, fmt), price_per_term_amount: per / 100,
        full_price: money(cents, fmt), full_price_amount: amt, eligible: n > 0 && amt >= payMeta.min_price_amount,
        available: v.available, number_of_payment_terms: n || 1 }];
      var old = payHost.querySelector('shopify-payment-terms');
      var fresh = document.createElement('shopify-payment-terms');
      fresh.setAttribute('variant-id', v.id);
      fresh.setAttribute('shopify-meta', JSON.stringify(meta));
      old.parentNode.replaceChild(fresh, old);
      var idf = payBox.querySelector('[name=id]');
      if (idf) idf.value = v.id;
    }

    var bundle = el.getAttribute('data-bundle');
    // Shopify won't sell a bundle on a subscription, so a subscribed bundle
    // goes in as its separate products (matching the chosen shade or scent),
    // each on the chosen plan. An included tool goes in as its own line; an
    // automatic discount in Shopify makes it free.
    function lineItems(v) {
      var sub = state.mode === 'sub' && v.plans && v.plans[state.plan];
      var items;
      if (sub && v.parts && v.parts.length) {
        items = v.parts.map(function (id) {
          return { id: id, quantity: 1, selling_plan: state.plan, properties: { 'Part of': data.part_of } };
        });
      } else {
        var item = { id: v.id, quantity: state.qty };
        if (sub) item.selling_plan = state.plan;
        if (bundle) item.properties = { '_appstle-bb-id': bundle };
        items = [item];
      }
      if (data.tool) items.push({ id: data.tool, quantity: 1, properties: { 'Included': 'Free with ' + data.part_of } });
      return items;
    }

    el.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-ac-mode]')) state.mode = t.value;
      else if (t.matches('[data-ac-plan]')) { state.plan = +t.value; state.mode = 'sub'; planTouched = true; }
      else if (t.matches('[data-ac-qty]')) { state.qty = +t.value || 1; planForQty(); }
      else if (t.matches('[data-ac-variant]')) {
        state.variant = +t.value;
        if (!picked) {
          picked = true;
          if (err) err.textContent = '';
          var box = el.querySelector('.ac-variants');
          if (box) box.classList.remove('is-need');
        }
      }
      else return;
      update();
    });

    function needPick() {
      if (picked) return false;
      if (err) err.textContent = needMsg;
      var box = el.querySelector('.ac-variants');
      if (box) {
        box.classList.add('is-need');
        box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
        var first = box.querySelector('[data-ac-variant]:not(:disabled)');
        if (first) first.focus({ preventScroll: true });
      }
      return true;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = variant();
      if (!v.available || needPick()) return;
      addToCart(lineItems(v), atc, err);
    });

    el.acBuy = function (btn) {
      var v = variant();
      if (needPick()) return;
      if (!v.available) { el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' }); return; }
      addToCart(lineItems(v), btn || atc, err);
    };
    update();
  }

  function Gallery(el) {
    var track = el.querySelector('.ac-gallery__track');
    var dots = el.querySelectorAll('[data-ac-dot]');
    var cap = el.querySelector('[data-ac-cap]');
    if (!track || dots.length < 2) return;
    var t;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.setAttribute('aria-current', n === i ? 'true' : 'false'); });
        // The offer photo's caption belongs to photo 1 only.
        if (cap) cap.style.visibility = i === 0 ? '' : 'hidden';
      }, 60);
    }, { passive: true });
    dots.forEach(function (d, n) {
      d.addEventListener('click', function () {
        track.scrollTo({ left: n * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' });
      });
    });
  }

  function Sticky(el) {
    var atc = document.querySelector('[data-ac-buy-box] [data-ac-atc]');
    var btn = el.querySelector('[data-ac-sticky-btn]');
    var priceEl = el.querySelector('[data-ac-sticky-price]');
    var pickEl = el.querySelector('[data-ac-sticky-pick]');
    document.addEventListener('ac:change', function (e) {
      if (priceEl) priceEl.textContent = e.detail.price + (e.detail.sub ? ' · ' + e.detail.plan : '');
      if (pickEl && e.detail.pick) pickEl.textContent = e.detail.pick;
      if (btn) btn.disabled = !e.detail.available;
    });
    if (!atc || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var r = entries[0];
      // On from the first screen (price + button up top), off while the buy box's own button shows.
      var on = !r.isIntersecting;
      el.classList.toggle('is-on', on);
      el.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }).observe(atc);
  }

  function Video(v) {
    if (reduced) { v.removeAttribute('autoplay'); v.setAttribute('controls', ''); return; }
    if (!('IntersectionObserver' in window)) { v.play && v.play().catch(function () {}); return; }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.25 }).observe(v);
  }

  function init(scope) {
    scope = scope || document;
    // Sticky bar first, so it hears the buy box's first price (2 tubes when that's picked).
    scope.querySelectorAll('[data-ac-sticky]').forEach(function (el) { if (!el.acReady) { el.acReady = 1; Sticky(el); } });
    scope.querySelectorAll('[data-ac-buy-box]').forEach(function (el) { if (!el.acReady) { el.acReady = 1; BuyBox(el); } });
    scope.querySelectorAll('[data-ac-gallery]').forEach(function (el) { if (!el.acReady) { el.acReady = 1; Gallery(el); } });
    scope.querySelectorAll('video[data-ac-autoplay]').forEach(function (el) { if (!el.acReady) { el.acReady = 1; Video(el); } });
  }

  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-ac-buy]');
    if (buy) {
      var box = document.querySelector('[data-ac-buy-box]');
      if (box && box.acBuy) { e.preventDefault(); box.acBuy(buy); }
      return;
    }
    var swap = e.target.closest('[data-ac-swap]');
    if (swap) {
      e.preventDefault();
      if (swap.getAttribute('aria-busy')) return;
      swapToRoutine(swap);
      return;
    }
    var add = e.target.closest('[data-ac-add]');
    if (add) {
      e.preventDefault();
      var err = add.parentNode.querySelector('[data-ac-error]');
      addToCart([{ id: +add.getAttribute('data-ac-add'), quantity: 1 }], add, err);
    }
  });

  // Free gift: the Ice, Roller & Gua Sha Trio on orders of $100 or more.
  // The ac-gift snippet (in the cart drawer) turns this on and lists the Trio's
  // variants. This adds the Trio when the cart qualifies and takes it out when
  // it doesn't. It keeps the Trio only if Shopify's automatic discount makes it
  // $0; if not, it takes it back out and stops trying for 30 minutes.
  // It runs on page load, when the theme announces a cart change, and after any
  // other script (a bundle or subscription app) changes the cart.
  var gift = { busy: false, again: false, timer: 0, hooked: false, changed: false, mine: 0, cfg: null };
  var GIFT_PAUSE = 30 * 60 * 1000;
  function giftCfg() {
    var el = document.querySelector('[data-ac-gift]');
    if (el) {
      try {
        gift.cfg = JSON.parse(el.textContent);
        try { sessionStorage.setItem('acGiftCfg', el.textContent); } catch (e) {}
        return gift.cfg;
      } catch (e) {}
    }
    if (!gift.cfg) {
      try { gift.cfg = JSON.parse(sessionStorage.getItem('acGiftCfg') || 'null'); } catch (e) {}
    }
    return gift.cfg;
  }
  function cartReq(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    gift.mine++;
    return fetch(root + path, opts).then(function (r) {
      if (!r.ok) throw new Error('cart ' + r.status);
      return r.json();
    }).then(function (j) { gift.mine--; return j; }, function (e) { gift.mine--; throw e; });
  }
  function giftState(cart, cfg) {
    var s = { total: 0, kit: false, line: null, paid: false, ok: false, reason: '' };
    cart.items.forEach(function (it) {
      var props = it.properties || {};
      if (it.selling_plan_allocation && cfg.kit && props['Part of'] === cfg.kit) s.kit = true;
      if (props._free_gift) { s.line = it; return; }
      if (it.product_id === cfg.trio || (cfg.pair && it.product_id === cfg.pair.product)) s.paid = true;
      if (it.final_line_price === 0 || it.product_id === cfg.scoop) return;
      s.total += it.final_line_price;
    });
    (cart.cart_level_discount_applications || []).forEach(function (d) { s.total -= d.total_allocated_amount || 0; });
    s.reason = s.total >= cfg.goal ? 'total' : (s.kit ? 'kit' : '');
    s.ok = !!s.reason;
    return s;
  }
  // A pause lasts 30 minutes, so a hiccup doesn't switch the gift off for the visit.
  function giftBlocked(reason) {
    try {
      var t = +sessionStorage.getItem('acGiftOff-' + reason) || 0;
      return Date.now() - t < GIFT_PAUSE;
    } catch (e) { return false; }
  }
  function giftBlock(reason) {
    try { sessionStorage.setItem('acGiftOff-' + reason, String(Date.now())); } catch (e) {}
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  // Redraw the cart drawer and cart count without opening the drawer.
  function refreshCart() {
    if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return Promise.resolve(); }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.getSectionInnerHTML !== 'function') return Promise.resolve();
    var secs = drawer.getSectionsToRender();
    var url = window.location.pathname + '?sections=' + secs.map(function (x) { return x.id; }).join(',');
    return fetch(url).then(function (r) { return r.json(); }).then(function (html) {
      secs.forEach(function (x) {
        var el = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
        if (el && html[x.id]) el.innerHTML = drawer.getSectionInnerHTML(html[x.id], x.selector);
      });
      drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', drawer.close.bind(drawer));
    });
  }
  // Grand opening (until Dec 31): each pair of one-time neck tubes becomes the
  // "2 Neck Creams + Free Trio" bundle, same $59.99, Trio included. Shopify's
  // discounts can't give both deals at once, so the bundle does it. Returns
  // the cart, changed or not.
  function pairSwap(cart, cfg) {
    var p = cfg.pair;
    if (!p || giftBlocked('pair')) return Promise.resolve(cart);
    var lines = cart.items.filter(function (it) {
      return it.product_id === p.neck && !it.selling_plan_allocation && !(it.properties || {})._free_gift;
    });
    var n = lines.reduce(function (a, it) { return a + it.quantity; }, 0);
    var pairs = Math.floor(n / 2);
    if (!pairs) return Promise.resolve(cart);
    var take = pairs * 2;
    var updates = {};
    lines.forEach(function (it) {
      var cut = Math.min(take, it.quantity);
      if (cut) { updates[it.key] = it.quantity - cut; take -= cut; }
    });
    var had = cart.items.reduce(function (a, it) { return a + (it.variant_id === p.bundle ? it.quantity : 0); }, 0);
    // Add the bundle first, so nothing vanishes from the cart. If the tubes
    // can't come out, take the bundle back out and stop trying for a while.
    return cartReq('cart/add.js', { items: [{ id: p.bundle, quantity: pairs }] })
      .then(function () {
        return cartReq('cart/update.js', { updates: updates }).catch(function (e) {
          var undo = {};
          undo[p.bundle] = had;
          return cartReq('cart/update.js', { updates: undo }).then(function () { throw e; });
        });
      })
      .catch(function () { giftBlock('pair'); })
      .then(function () { return cartReq('cart.js'); });
  }
  function giftCheck(cfg) {
    var swapped = false;
    return cartReq('cart.js').then(function (before) {
      return pairSwap(before, cfg).then(function (cart) {
        swapped = cart.item_count !== before.item_count || cart.items.length !== before.items.length;
        return cart;
      });
    }).then(function (cart) {
      var r = giftFix(cart, cfg);
      return r || (swapped ? refreshCart() : undefined);
    });
  }
  function giftFix(cart, cfg) {
    var s = giftState(cart, cfg);
    if (s.line && (!s.ok || s.paid)) return cartReq('cart/change.js', { id: s.line.key, quantity: 0 }).then(refreshCart);
    if (s.line && s.line.quantity !== 1) return cartReq('cart/change.js', { id: s.line.key, quantity: 1 }).then(refreshCart);
    if (s.line || !s.ok || s.paid || giftBlocked(s.reason) || !cfg.variants.length) return;
    return cartReq('cart/add.js', { items: [{ id: cfg.variants[0], quantity: 1, properties: { _free_gift: 'trio' } }] })
      .then(function () { return cartReq('cart.js'); })
      .then(function (after) {
        var g = giftState(after, cfg).line;
        if (!g || g.final_line_price === 0) return;
        // Discounts can take a moment to land. Look once more before giving up.
        return wait(1200).then(function () { return cartReq('cart.js'); }).then(function (again) {
          var g2 = giftState(again, cfg).line;
          if (g2 && g2.final_line_price > 0) {
            giftBlock(s.reason);
            return cartReq('cart/change.js', { id: g2.key, quantity: 0 });
          }
        });
      })
      .then(refreshCart);
  }
  function giftRun() {
    var cfg = giftCfg();
    var changed = gift.changed;
    if (!cfg) {
      // The cart was empty when the page loaded, so the drawer has no settings
      // yet. Redraw it once to get them.
      if (changed) refreshCart().then(function () { if (giftCfg()) giftSoon(); }).catch(function () {});
      return;
    }
    if (!cfg.on) return;
    // If the cart hasn't changed since the page loaded, the cart drawer already
    // worked out whether anything needs to change.
    if (!changed && cfg.need === 'none') return;
    if (gift.busy) { gift.again = true; return; }
    gift.busy = true;
    giftCheck(cfg).catch(function () {}).then(function () {
      gift.busy = false;
      if (gift.again) { gift.again = false; giftSoon(); }
    });
  }
  // onLoad is true only for the first check when the page opens. Every other
  // call means the cart may have changed.
  function giftSoon(ms, onLoad) {
    if (!onLoad) gift.changed = true;
    clearTimeout(gift.timer);
    gift.timer = setTimeout(giftRun, typeof ms === 'number' ? ms : 80);
  }
  // Notice cart changes made by other scripts (apps) that don't tell the theme.
  function giftWatch() {
    var re = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
    function seen(url) {
      try { if (re.test(String(url && url.url ? url.url : url))) giftSoon(600); } catch (e) {}
    }
    if (window.fetch && !window.fetch.acGift) {
      var f = window.fetch;
      var wrapped = function (input) {
        var p = f.apply(this, arguments);
        var mine = gift.mine > 0;
        if (!mine) p.then(function () { seen(input); }, function () {});
        return p;
      };
      wrapped.acGift = true;
      window.fetch = wrapped;
    }
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.acGift) {
      var open = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (m, url) {
        this.addEventListener('loadend', function () { seen(url); });
        return open.apply(this, arguments);
      };
      XMLHttpRequest.prototype.acGift = true;
    }
  }
  // Run on page load and after every cart change.
  function giftStart() {
    try {
      if (!gift.hooked && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { giftSoon(); });
        gift.hooked = true;
      }
    } catch (e) {}
    try { giftWatch(); } catch (e) {}
    window.addEventListener('pageshow', function (e) { if (e.persisted) giftSoon(); });
    giftSoon(80, true);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.AC = { init: init, money: money, addToCart: addToCart, gift: giftSoon };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); giftStart(); });
  else { init(); giftStart(); }
})();
  } catch(e) { console.error(e); }
})();

})();
